// extracted by mini-css-extract-plugin
export var equalColumn = "_redotech-redo-web-lib-address-autocomplete-form-equal-column";